export var popoverDriver = function (documentWrapper, specificClassName) {
    var maybeClassName = specificClassName ? "." + specificClassName : '';
    return documentWrapper.$(".Popover" + maybeClassName);
};
export var createUncontrolledPopoverDriver = function (wrapper) {
    var popoverTriggerBase = wrapper.$(".popover-clickable-body-container");
    var popoverBodyDriver = popoverDriver(wrapper);
    return {
        openPopover: function () { return popoverTriggerBase.click(); },
        popoverBodyDriver: popoverBodyDriver,
        popoverTriggerBase: popoverTriggerBase,
    };
};
//# sourceMappingURL=driver.js.map